module.exports = __webpack_public_path__ + "static/media/Paola_Lizbeth_Angeles_Pacheco_2.cfb47948.jpg";